export const translations = {
  cs: {
    nav: {
      home: "Domů",
      services: "Služby",
      about: "O nás",
      contact: "Kontakt",
      cta: "Domluvit projekt",
    },
    home: {
      hero_kicker: "Digitální studio · Praha",
      hero_title_a: "Tvoříme",
      hero_title_b: "digitální.",
      hero_title_c: "Jinak.",
      hero_lede:
        "Navrhujeme a stavíme weby, aplikace a automatizace, které posouvají byznys vpřed. Bez šablon, bez kompromisů.",
      cta_start: "Začít projekt",
      cta_services: "Co děláme",
      stats: [
        { v: "10+", l: "služeb pod jednou střechou" },
        { v: "100%", l: "vlastní řešení" },
        { v: "24/7", l: "podpora projektů" },
        { v: "PRG", l: "Praha 8 · Střížkov" },
      ],
      marquee_items: [
        "Web Apps",
        "E-commerce",
        "Telegram Boty",
        "Automatizace",
        "Integrace API",
        "SEO",
        "UI/UX",
        "Reklama",
        "Konzultace",
      ],
      services_kicker: "Vybrané služby",
      services_title: "Hluboká expertíza,",
      services_title_b: "ostrá realizace.",
      services_lede:
        "Od první skici po nasazení a údržbu. Pracujeme po celé délce produktu.",
      about_kicker: "O studiu",
      about_title_a: "Malý tým.",
      about_title_b: "Velké ambice.",
      about_lede:
        "Terwilliger s.r.o. je pražské digitální studio. Spojujeme inženýrské řemeslo s vizuální disciplínou — výsledkem jsou produkty, které prostě fungují.",
      about_link: "Zjistit víc",
      cta_block_kicker: "Pojďme do toho",
      cta_block_title_a: "Máte nápad?",
      cta_block_title_b: "Postavíme ho.",
      cta_block_lede:
        "Napište nám pár řádků o tom, co chcete dokázat. Ozveme se do 24 hodin.",
    },
    services: {
      kicker: "Služby · 2026",
      title_a: "Co",
      title_b: "děláme.",
      lede:
        "Devět hlavních směrů, jeden tým. Vyberte si jeden — nebo postavme společně něco kompletního.",
      tech_kicker: "Technologie",
      tech_title: "Stack, kterému věříme.",
      tech_lede:
        "Pracujeme s ověřenými open-source nástroji. Bez vendor lock-in, bez magie.",
      cta_kicker: "Další krok",
      cta_title: "Připraveni začít?",
      cta_lede: "Domluvíme si 30 minut a probereme váš projekt.",
      list: [
        {
          n: "01",
          title: "Vývoj webových stránek",
          desc:
            "Landingy, e-shopy, korporátní weby. Rychlé, dobře strukturované, optimalizované pro výkon i SEO.",
          tags: ["Next.js", "React", "Headless CMS"],
        },
        {
          n: "02",
          title: "Webové aplikace a služby",
          desc:
            "Vlastní SaaS, dashboardy, interní nástroje. Architektura, která vydrží růst.",
          tags: ["FastAPI", "Node", "PostgreSQL", "MongoDB"],
        },
        {
          n: "03",
          title: "Telegram boti a chatboti",
          desc:
            "Boti pro zákaznickou podporu, prodej, oznámení. Integrace s vaším CRM a platebními bránami.",
          tags: ["Telegram API", "OpenAI", "n8n"],
        },
        {
          n: "04",
          title: "Automatizace byznys procesů",
          desc:
            "Méně ručních úkonů, více času na růst. Workflow, které pracují za vás 24/7.",
          tags: ["n8n", "Make", "Zapier", "Custom"],
        },
        {
          n: "05",
          title: "Integrace (CRM, platby, API)",
          desc:
            "Propojíme vaše nástroje. Stripe, GoPay, HubSpot, Pipedrive, ERP — ať data tečou kam mají.",
          tags: ["Stripe", "GoPay", "REST", "Webhooks"],
        },
        {
          n: "06",
          title: "Nastavení a vedení reklamy",
          desc:
            "Google Ads, Meta, LinkedIn. Strategie, kreativa, optimalizace. Měřitelné výsledky.",
          tags: ["Google Ads", "Meta", "GA4"],
        },
        {
          n: "07",
          title: "SEO propagace",
          desc:
            "Technické SEO, obsahová strategie, link building. Dlouhodobý růst organické návštěvnosti.",
          tags: ["Tech SEO", "Content", "Audit"],
        },
        {
          n: "08",
          title: "Doplnění a podpora projektů",
          desc:
            "Převezmeme váš stávající projekt. Refaktor, nové funkce, údržba, security audit.",
          tags: ["Refactor", "DevOps", "Audit"],
        },
        {
          n: "09",
          title: "UI/UX design",
          desc:
            "Od research po prototyp. Rozhraní, která lidé chápou bez návodu.",
          tags: ["Figma", "Research", "Design System"],
        },
        {
          n: "10",
          title: "Konzultace pro rozvoj",
          desc:
            "Strategická setkání, technické audity, mapování příležitostí. 60 minut, které ušetří měsíce.",
          tags: ["Strategy", "Audit", "Roadmap"],
        },
      ],
      stack: [
        "React",
        "Next.js",
        "FastAPI",
        "Node.js",
        "MongoDB",
        "PostgreSQL",
        "Stripe",
        "Tailwind",
        "Framer Motion",
        "n8n",
        "Telegram API",
        "OpenAI",
      ],
    },
    about: {
      kicker: "O nás",
      title_a: "Studio z Prahy.",
      title_b: "Pro celý svět.",
      lede:
        "Terwilliger s.r.o. je nezávislé digitální studio sídlící v Praze 8. Stavíme produkty, ne prezentace.",
      manifesto_title: "Manifest",
      manifesto: [
        "Pracujeme s vámi, ne pro vás. Klient je součást týmu.",
        "Jednoduchost je nejvyšší forma sofistikovanosti. Méně, ale lépe.",
        "Kód, který nepřežije rok, je technický dluh. Píšeme nadčasově.",
        "Design bez výsledku je dekorace. Měříme to, co se počítá.",
      ],
      facts_kicker: "Fakta",
      facts: [
        { k: "Společnost", v: "Terwilliger s.r.o." },
        { k: "IČO", v: "22293191" },
        { k: "Sídlo", v: "Děčínská 552/1, Střížkov" },
        { k: "Město", v: "180 00 Praha 8" },
        { k: "Telefon", v: "+420 731 385 947" },
        { k: "Založeno", v: "Praha · CZ" },
      ],
      values_kicker: "Hodnoty",
      values_title: "V co věříme.",
      values: [
        {
          t: "Řemeslo",
          d: "Detail rozhoduje. Píšeme čistý kód a navrhujeme rozhraní, která vydrží.",
        },
        {
          t: "Transparence",
          d: "Otevřená komunikace, jasné odhady, žádná překvapení v poslední fázi.",
        },
        {
          t: "Rychlost",
          d: "Iterujeme rychle. První funkční verze do týdnů, ne měsíců.",
        },
        {
          t: "Partnerství",
          d: "Nejsme dodavatel. Jsme dlouhodobý partner pro váš digitální růst.",
        },
      ],
    },
    contact: {
      kicker: "Kontakt",
      title_a: "Pojďme",
      title_b: "to spojit.",
      lede:
        "Nejjednodušší cesta? Napište pár řádků. Ozveme se do 24 hodin a domluvíme krátký hovor.",
      form_name: "Vaše jméno",
      form_email: "E-mailová adresa",
      form_subject: "Předmět",
      form_message: "Popište projekt — rozsah, cíl, termíny",
      form_send: "Odeslat zprávu",
      form_note: "Otevře se váš e-mailový klient s předvyplněnou zprávou.",
      info_kicker: "Spojení",
      info_address_label: "Adresa",
      info_phone_label: "Telefon",
      info_email_label: "E-mail",
      info_id_label: "IČO",
      info_hours_label: "Otevírací doba",
      info_hours_value: "Po – Pá · 9:00 – 18:00",
      validation_required: "Vyplňte prosím všechna povinná pole.",
    },
    footer: {
      tagline: "Digitální studio · Praha",
      sections: {
        nav: "Navigace",
        services: "Služby",
        contact: "Kontakt",
      },
      services_short: [
        "Web & E-commerce",
        "Web aplikace",
        "Boti & Automatizace",
        "Integrace & API",
        "Reklama & SEO",
        "UI/UX design",
      ],
      copyright: "Terwilliger s.r.o. — Všechna práva vyhrazena.",
      ico: "IČO: 22293191",
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      contact: "Contact",
      cta: "Start a project",
    },
    home: {
      hero_kicker: "Digital studio · Prague",
      hero_title_a: "We build",
      hero_title_b: "digital.",
      hero_title_c: "Differently.",
      hero_lede:
        "We design and ship websites, applications and automations that move the needle. No templates, no compromises.",
      cta_start: "Start a project",
      cta_services: "What we do",
      stats: [
        { v: "10+", l: "services under one roof" },
        { v: "100%", l: "custom solutions" },
        { v: "24/7", l: "project support" },
        { v: "PRG", l: "Prague 8 · Střížkov" },
      ],
      marquee_items: [
        "Web Apps",
        "E-commerce",
        "Telegram Bots",
        "Automation",
        "API Integrations",
        "SEO",
        "UI/UX",
        "Advertising",
        "Consulting",
      ],
      services_kicker: "Selected services",
      services_title: "Deep expertise,",
      services_title_b: "sharp execution.",
      services_lede:
        "From first sketch to deployment and ongoing support. We work the full length of the product.",
      about_kicker: "About the studio",
      about_title_a: "Small team.",
      about_title_b: "Big ambition.",
      about_lede:
        "Terwilliger s.r.o. is a Prague-based digital studio. We combine engineering craft with visual discipline — and ship products that simply work.",
      about_link: "Learn more",
      cta_block_kicker: "Let's go",
      cta_block_title_a: "Got an idea?",
      cta_block_title_b: "We'll build it.",
      cta_block_lede:
        "Drop us a few lines about what you want to achieve. We'll get back within 24 hours.",
    },
    services: {
      kicker: "Services · 2026",
      title_a: "What",
      title_b: "we do.",
      lede:
        "Nine main directions, one team. Pick one — or let's build something complete together.",
      tech_kicker: "Technology",
      tech_title: "The stack we trust.",
      tech_lede:
        "We work with proven open-source tools. No vendor lock-in, no magic.",
      cta_kicker: "Next step",
      cta_title: "Ready to start?",
      cta_lede: "Let's set up 30 minutes to discuss your project.",
      list: [
        {
          n: "01",
          title: "Website development",
          desc:
            "Landings, e-commerce, corporate sites. Fast, well-structured, optimized for performance and SEO.",
          tags: ["Next.js", "React", "Headless CMS"],
        },
        {
          n: "02",
          title: "Web apps and services",
          desc:
            "Custom SaaS, dashboards, internal tools. Architecture that scales.",
          tags: ["FastAPI", "Node", "PostgreSQL", "MongoDB"],
        },
        {
          n: "03",
          title: "Telegram bots and chatbots",
          desc:
            "Bots for support, sales and notifications. Integrated with your CRM and payment gateways.",
          tags: ["Telegram API", "OpenAI", "n8n"],
        },
        {
          n: "04",
          title: "Business process automation",
          desc:
            "Less manual work, more time for growth. Workflows that run for you 24/7.",
          tags: ["n8n", "Make", "Zapier", "Custom"],
        },
        {
          n: "05",
          title: "Integrations (CRM, payments, API)",
          desc:
            "We connect your stack. Stripe, GoPay, HubSpot, Pipedrive, ERP — data flows where it should.",
          tags: ["Stripe", "GoPay", "REST", "Webhooks"],
        },
        {
          n: "06",
          title: "Advertising setup & management",
          desc:
            "Google Ads, Meta, LinkedIn. Strategy, creatives, optimization. Measurable outcomes.",
          tags: ["Google Ads", "Meta", "GA4"],
        },
        {
          n: "07",
          title: "SEO promotion",
          desc:
            "Technical SEO, content strategy, link building. Long-term organic growth.",
          tags: ["Tech SEO", "Content", "Audit"],
        },
        {
          n: "08",
          title: "Project support & maintenance",
          desc:
            "We take over your existing project. Refactor, new features, maintenance, security audit.",
          tags: ["Refactor", "DevOps", "Audit"],
        },
        {
          n: "09",
          title: "UI/UX design",
          desc:
            "From research to prototype. Interfaces people understand without a manual.",
          tags: ["Figma", "Research", "Design System"],
        },
        {
          n: "10",
          title: "Growth consulting",
          desc:
            "Strategy sessions, technical audits, opportunity mapping. 60 minutes that save months.",
          tags: ["Strategy", "Audit", "Roadmap"],
        },
      ],
      stack: [
        "React",
        "Next.js",
        "FastAPI",
        "Node.js",
        "MongoDB",
        "PostgreSQL",
        "Stripe",
        "Tailwind",
        "Framer Motion",
        "n8n",
        "Telegram API",
        "OpenAI",
      ],
    },
    about: {
      kicker: "About",
      title_a: "Studio from Prague.",
      title_b: "For the world.",
      lede:
        "Terwilliger s.r.o. is an independent digital studio in Prague 8. We build products, not pitch decks.",
      manifesto_title: "Manifesto",
      manifesto: [
        "We work with you, not for you. The client is part of the team.",
        "Simplicity is the highest sophistication. Less, but better.",
        "Code that won't survive a year is technical debt. We write to last.",
        "Design without outcome is decoration. We measure what counts.",
      ],
      facts_kicker: "Facts",
      facts: [
        { k: "Company", v: "Terwilliger s.r.o." },
        { k: "Reg. No.", v: "22293191" },
        { k: "Address", v: "Děčínská 552/1, Střížkov" },
        { k: "City", v: "180 00 Prague 8" },
        { k: "Phone", v: "+420 731 385 947" },
        { k: "Founded", v: "Prague · CZ" },
      ],
      values_kicker: "Values",
      values_title: "What we stand for.",
      values: [
        {
          t: "Craft",
          d: "Detail decides. Clean code, interfaces that age well.",
        },
        {
          t: "Transparency",
          d: "Open communication, clear estimates, no last-minute surprises.",
        },
        {
          t: "Speed",
          d: "Fast iteration. First working version in weeks, not months.",
        },
        {
          t: "Partnership",
          d: "We're not a vendor. We're a long-term partner for your growth.",
        },
      ],
    },
    contact: {
      kicker: "Contact",
      title_a: "Let's",
      title_b: "connect.",
      lede:
        "Easiest path? Drop us a few lines. We'll respond within 24 hours and set up a quick call.",
      form_name: "Your name",
      form_email: "Email address",
      form_subject: "Subject",
      form_message: "Tell us about the project — scope, goal, timeline",
      form_send: "Send message",
      form_note: "Your email client will open with a pre-filled message.",
      info_kicker: "Get in touch",
      info_address_label: "Address",
      info_phone_label: "Phone",
      info_email_label: "Email",
      info_id_label: "Reg. No.",
      info_hours_label: "Hours",
      info_hours_value: "Mon – Fri · 9:00 – 18:00",
      validation_required: "Please fill all required fields.",
    },
    footer: {
      tagline: "Digital studio · Prague",
      sections: {
        nav: "Navigation",
        services: "Services",
        contact: "Contact",
      },
      services_short: [
        "Web & E-commerce",
        "Web apps",
        "Bots & Automation",
        "Integrations & API",
        "Ads & SEO",
        "UI/UX design",
      ],
      copyright: "Terwilliger s.r.o. — All rights reserved.",
      ico: "Reg. No.: 22293191",
    },
  },
};
